//this creates an app-icon which when clicked will open a popover which is placed in the middle of the screen (so opoover is not attached to triggering button)
angular.module('cfn').directive('fnStockFillDisplay', function() {
  return {
    restrict: 'E',
    scope: {
      value: '=',
      valueMax: '=',
      alarmLevel: '=',
      type: '@'
    },
    replace: false,
    templateUrl: require('./cfn-stock-fill-display.tpl.html'),
    controller: [
      '$scope',
      '$element',
      '$filter',
      function($scope, $element, $filter) {
        var ctrl = this;

        $scope.$watch('alarmLevel', function() {
          $scope.alarm = $scope.alarmLevel > 0;
        });

        $scope.reScaleDisplayValue = function(value) {
          var value = $scope.reScalePercent(value);
          if (value > 100) value = 100;

          var factor =
            ($scope.settings.height - $scope.settings.lineSize * 2) /
            $scope.settings.height;

          return (
            value * factor +
            $scope.settings.lineSize * 100 / $scope.settings.height
          );
        };
        $scope.reScalePercent = function(value) {
          if (!value) value = 0;

          if ($scope.valueMax) {
            value = value * 100.0 / $scope.valueMax;
          } else {
            value = 0;
          }
          value = Math.round(value);
          return value;
        };

        $scope.$watch('type', function() {
          console.debug('type cahnged', $scope.type);
          if ($scope.type == 'silo') {
            $scope.settings = {
              fileName: 'fip/silo',
              fillHeight: 270,

              paddingLeft: '66px',
              width: 100,
              height: 270,
              lineDisplay: true,
              lineSize: 25,
              fill: {
                left: 10,
                top: 14,
                width: 80,
                height: 243
              }
            };
          } else if ($scope.type == 'standard') {
            $scope.settings = {
              fileName: 'fip/standardTank',
              width: 115,
              height: 75
            };
          } else {
            // default is milktank
            //if(type=='feedsilo')
            $scope.settings = {
              fileName: 'fip/milkTank',
              fillHeight: 80,

              paddingLeft: '5px',
              width: 270,
              height: 100,
              lineSize: 0,
              fill: {
                left: 14,
                top: 10,
                width: 243,
                height: 80
              }
            };
          }
        });

        $scope.onMouseDown = function(event) {
          var height = $('.clickTarget', $element).height();

          var parentOffset = $('.clickTarget', $element).offset();
          //or $(this).offset(); if you really just want the current element's offset
          var relX = event.pageX - parentOffset.left;
          var y = event.pageY - parentOffset.top;

          if (y <= 0) y = 0;
          if (y >= height - 1) y = height - 1;

          var level = 1 - y / (height - 1);
          if ($scope.valueMax) {
            $scope.alarmLevel = level * $scope.valueMax;

            console.debug('alarmLevel', $scope.alarmLevel);
          } else {
            $scope.alarmLevel = undefined;
            $scope.alarm = false;
          }
          if (level) $scope.alarm = true;
          else $scope.alarm = false;
        };

        $element.mousedown(function(event) {
          $scope.mouseDown = true;
          if ($(event.target).hasClass('clickTarget')) {
            event.stopPropagation();
            ang.apply($scope, function() {
              $scope.onMouseDown(event);
            });
          }
        });
        $element.mousemove(function(event) {
          if ($scope.mouseDown)
            if ($(event.target).hasClass('clickTarget')) {
              event.stopPropagation();
              ang.apply($scope, function() {
                $scope.onMouseDown(event);
              });
            }
        });
        $element.mouseup(function(event) {
          $scope.mouseDown = false;
        });
      }
    ]
  };
});
